<template>
  <b-form @submit.prevent>
    <b-row class="mt-2">
      <!-- Status -->
      <b-col cols="12">
        <b-form-group
          label="Estado:"
          label-for="status"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="status"
              :value="item.status === 'active' ? 'Activa' : 'No Activa'"
              :state="item.status === 'active' ? false : true"
              placeholder="Estado"
              disabled
              :class="item.status === 'active' ? 'text-danger' : 'text-success'"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Alert -->
      <b-col cols="12">
        <b-form-group
          label="Alerta:"
          label-for="alert"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="AlertTriangleIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="alert"
              :value="item.alert ? item.alert : ''"
              placeholder="Alerta"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Date Active -->
      <b-col cols="12">
        <b-form-group
          label="Activación:"
          label-for="date"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="CalendarIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="date"
              :value="$moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')"
              placeholder="Fecha"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Date Inactive -->
      <b-col cols="12">
        <b-form-group
          label="Desactivación:"
          label-for="inactive_date"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="CalendarIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="inactive_date"
              :value="item.status === 'inactive' ? $moment(item.updatedAt).format('DD/MM/YYYY HH:mm:ss') : ''"
              placeholder="Fecha Desactivación"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Value Alert-->
      <b-col

        cols="12"
      >
        <b-form-group
          label="Valor de Alerta:"
          label-for="value_alert"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="TrendingUpIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="value_alert"
              :value="formatValueAlert(item.typeAlert, item.valueAlert)"
              placeholder="Valor de Alerta"
              class="text-danger"
            />
            <b-input-group-append v-if="item.typeAlert !== 'status'" is-text>
              <strong>
                {{ `${item.operator ? item.operator : item.typeAlert === 'boolean' ? '=' : '' } ${formatValueAlert(item.typeAlert, item.valueThreshold)}` }}
              </strong>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Pozo -->
      <b-col cols="12">
        <b-form-group
          label="Ubicación:"
          label-for="location"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="MapPinIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="location"
              :value="item.site ? item.site : ''"
              placeholder="Ubicación"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Device -->
      <b-col cols="12">
        <b-form-group
          label="Dispositivo:"
          label-for="device"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SmartphoneIcon" />
            </b-input-group-prepend>
            <b-form-input
              id="device"
              :value="item.device ? item.device : ''"
              placeholder="Dispositivo"
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- Info User -->
      <b-col
        v-if="item.id > 0"
        cols="12"
      >
        <b-form-group
          label="Creado por:"
          label-for="user"
          label-cols-md="4"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="user"
              :value="item.user === 'system' ? 'Sistema' : item.user"
              placeholder="Creado por:"
              disabled
            />
          </b-input-group>
        </b-form-group>
      </b-col>

      <!-- btn centered actions-->
      <b-col class="text-center mt-2">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="reset"
          variant="outline-secondary"
          @click="close"
        >
          Cancelar
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="ml-4"
          :disabled="loading"
          @click="save"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ loading ? 'Procesando...' : 'Desactivar' }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BFormGroup, BFormInput, BForm, BInputGroup, BInputGroupPrepend, BInputGroupAppend, BRow, BCol,
  BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import moment from 'moment-timezone'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BForm,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: [],
    }
  },
  methods: {
    save() {
      this.$emit('save')
    },
    close() {
      this.$emit('close')
    },
    formatValueAlert(typeAlert, value) {
      if (value === undefined || value === null || !value) {
        return ''
      }
      switch (typeAlert) {
        case 'number':
          return parseFloat(value).toFixed(2)
        case 'status':
          return moment.utc(value).local().format('DD/MM/YYYY hh:mm:ss a')
        default:
          return value
      }
    },
  },
}
</script>
